import { Component, Input, OnInit } from '@angular/core';
import { HomeButton } from '../../models/home-button';

@Component({
  selector: 'app-home-button',
  templateUrl: './home-button.component.html',
  styleUrls: ['./home-button.component.scss'],
  styles: [`
  >>> app-home-button {
    width: 100%;
  }
`]
})
export class HomeButtonComponent implements OnInit {

  @Input() data: HomeButton = new HomeButton();
  constructor() { }

  ngOnInit() {
  }

}
